module.exports = __webpack_public_path__ + "img/Sebastiankuehnel_quad.5e72f863.jpg";